module.exports = __webpack_public_path__ + "img/biometricaccesscontrol.bdb29fe9.jpeg";